<div class="demo">
  <pa-info-block blockTitle="Степпер в модальном окне">
    <p>Двухшаговый сценарий в правой модалке.</p>
    <pa-button label="Открыть модалку со степпером" (click)="openStepperModal()"></pa-button>
  </pa-info-block>
</div>
